export default "__VITE_ASSET__DcHqFy3G__"